import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  const footerLinks = {
    [t('footer.product')]: [
      { name: t('navigation.technology'), href: '#technology' },
      { name: t('navigation.features'), href: '#features' },
      { name: t('navigation.swarm'), href: '#swarm-analysis' },
    ],
    [t('footer.resources')]: [
      { name: t('navigation.whitepaper'), href: '/whitepaper' },
      { name: t('navigation.technicalPaper'), href: '/technical-paper' },
      { name: t('navigation.terms'), href: '/terms-and-conditions' },
      { name: t('navigation.github'), href: 'https://github.com/jnodes/shby' },
    ],
  };



  return (
    <footer className="relative border-t border-border bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_567a6262-0291-4069-9a05-5048d6f99ff3/artifacts/3eapd20t_logo.png"
                alt="Shenbury"
                className="h-8 w-8"
              />
              <span className="text-xl font-serif font-semibold text-gradient-primary">
                Shenbury
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              {t('footer.description')}
            </p>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-serif font-semibold text-foreground mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="text-sm text-muted-foreground hover:text-primary-glow transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              {t('footer.copyright').replace('{year}', currentYear)}
            </p>
          </div>
          <p className="text-xs text-muted-foreground text-center">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
};